// import "font-awesome/css/font-awesome.min.css";

import React, { Component } from "react";
import CryptoJS from "crypto-js";
import { connect } from "react-redux";
import Summary from "./Summary/Summary";
import SummaryRTL from "./SummaryRTL/SummaryRTL";
import { assessmentActions, questionsActions, panelActions } from "../../_actions";
import AssessmentReport from "./Component/AssessmentReport/AssessmentReport";
import AssessmentReportRTL from "./Component/AssessmentReportRTL/AssessmentReportRTL";
import moment from "moment";
import VideoCourse from "./VideoCourse/VideoCourse";
import DashboardUser from "../AdminPanel/Dashboard/DashboardUser";

class AssessmentOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReportModal: this.props.match.params.id === '2' ? true : false,
      showPageType: this.props.match.params.id,


      isDisableSubmit: false,

      SurveyCode: this.props.codeValue,

      radioButton: false,
      radioButton2: false,
      currQues: null,
      showWelcomeScreen: true,
      showQuestionScreen: false,
      showThankyouScreen: false,
      instructionPage: false,
      showRedFlag: false,
      saveMsg: "",
      CurrQuesIndex: 1,
      submitSucces: false,

      surveyLanguageName: "English",
      ShowSubmitButton: false,

      textAnswer: "",
      unattemptList: [],
      changeType: "fade",
      mandatoryOn: false,
      afterSubmitData: {
        thankyouText: "",
        bgColor: "",
        bgImage: "",
        textcolor: "",
        logo: "",
      },
      alreadySubmitted: false,
      clicked: false,

      showDropdownQues: false,
      dropdownInput: "",
      scrollPosition: 0,
      IpObj: {},
      ShowNotAttempted: false,
      submitMandatory: "",
      setTimeoutRef: "",
      setTimeoutInit: 0,
      disableTimer: false,
      timeCounter: 0,
      setIntervalRef: "",
      showSummaryReport: false,
      showViewReportThankYouButton: false,
      surveyLanguageCode: 'en',

      themeType: 2,

      showNameEditScreen: false,
      nameFormData: {
        'name': '',
        'email': ''
      },
      errNameForm: {
        'name': '',
        'email': ''
      },


      backSummary: false,
      showMainSummaryModal: false,
      crrDetail: "",
      crrCodeUserDetails: {
        "employeeId": "",
        "name": "",
        "email": "",
        "mobile": "",
        "message": ""
      },
      topFiveTalent: true,
      contactExpertSection: false,
      showMyExpertList: false,
      submitBlock: false


    };


    this.handleShowMainSummaryModal = this.handleShowMainSummaryModal.bind(this);
    this.handleShowMainSummaryModalBack = this.handleShowMainSummaryModalBack.bind(this);
    this.handleExpertContactModalBack = this.handleExpertContactModalBack.bind(this);
    this.handleExpertContactModal = this.handleExpertContactModal.bind(this);
    this.handleInputExpertForm = this.handleInputExpertForm.bind(this);
    this.bookExpert = this.bookExpert.bind(this);
    this.handleExpertClick = this.handleExpertClick.bind(this);


  }

  componentDidMount() {
    this.props.dispatch(questionsActions.emptyReducer());

    this.props.dispatch(questionsActions.getAssessmentReport());

    if (this.state.showPageType === '3') {
      this.props.dispatch(assessmentActions.getTalentResources());
    }

    this.props.dispatch(questionsActions.getLanguageLabel());

    this.props.dispatch(questionsActions.getTranslateElementAll());


  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.questions.submitfail) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: false,

        alreadySubmitted: true,
      };
    }
    if (nextProps.questions.answerSubmitSuccess) {
      return {
        ...nextProps,
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: true,
        instructionPage: false,
      };
    } else {
      return {
        ...nextProps,
      };
    }
  }

  prevQues = () => {
    this.setState({ changeType: "fade1" });
    this.setState({ ShowSubmitButton: false });
    this.setState({ submitMandatory: "" });

    let { questions } = this.props;
    let { questionsList } = questions;

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex > 1 && CurrQuesIndex < questionsList.length + 1) {
        CurrQuesIndex = CurrQuesIndex - 1;

        this.setState({ CurrQuesIndex }, () => {
          // this.handleSubmitAppear();
        });
      } else {
        this.setState({
          showWelcomeScreen: false,
          showQuestionScreen: false,
          showThankyouScreen: false,
          instructionPage: true,
        });
      }
    }

    // //console.log("answersList: ", answersList)
  };

  nextQues = (type2) => {
    //console.log("Next Question!");
    clearTimeout(this.state.setTimeoutRef);
    clearInterval(this.state.setIntervalRef);

    window.scrollTo(0, 0);

    this.setState({ changeType: "fade", clicked: "" }, () => {
      let { questions } = this.props;
      let { questionsList, surveyScreenData, GroupQuestionOnlyList } =
        questions;

      let { CurrQuesIndex } = this.state;

      // //console.log("<---->------>2");

      let itemQ =
        questionsList && questionsList.length > 0
          ? questionsList[CurrQuesIndex]
          : {};

      ////console.log("itemQ--" + (CurrQuesIndex + 1).toString() + "-->", itemQ);

      //---------------------------- basic ---------------------------------------
      let answersList = [];
      let AnswerListFinal =
        answersList && questions.answersList && questions.answersList.length > 0
          ? questions.answersList
          : [];

      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex < questions.questionsList.length) {
          this.props.dispatch(
            questionsActions.handleRecordResTime(
              0,
              itemQ,
              AnswerListFinal,
              questionsList,
              surveyScreenData,
              GroupQuestionOnlyList
            )
          );
        }

        questionsList.forEach((ques) => {
          if (ques.templateId === 13) {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push({
                ...AnswerListFinal[getIndex],
                SubQuestionList: ques.SubQuestionList,
              });
            }
          } else {
            let getIndex = AnswerListFinal.findIndex(
              (prev) => prev.questionId === ques.id
            );
            if (getIndex !== -1) {
              answersList.push(AnswerListFinal[getIndex]);
            }
          }
        });
      }
      //-------------------------------------------------------------------
      let isFeedback = false;
      if (questionsList && questionsList.length > 0) {
        if (CurrQuesIndex > 0 && CurrQuesIndex < questionsList.length) {
          //----------------latestcode ---------------------------
          ////console.log("11111111111------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};
          let flag = 0;

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }

              if (item.isMandatory) {
                let template = item.template;

                if (
                  template === 1 ||
                  template === 3 ||
                  template === 4 ||
                  template === 5 ||
                  template === 6 ||
                  template === 16 ||
                  template === 11
                ) {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                } else if (template === 13) {
                  let isAllAnswered = 0;
                  if (
                    item &&
                    item.SubQuestionList &&
                    item.SubQuestionList.length > 0
                  ) {
                    item.SubQuestionList.forEach((subQues) => {
                      let getIndex2 = AnswerListFinal.findIndex(
                        (prev) => prev.questionId === subQues.id
                      );

                      if (getIndex2 !== -1) {
                        if (
                          AnswerListFinal &&
                          AnswerListFinal[getIndex2] &&
                          AnswerListFinal[getIndex2].multiAnswer &&
                          AnswerListFinal[getIndex2].multiAnswer.length > 1
                        ) {
                          isAllAnswered++;
                        }
                      }
                    });
                  }

                  if (item.SubQuestionList.length !== isAllAnswered) {
                    flag = flag + 1;
                  }
                } else if (template === 2) {
                  if (
                    !(item && item.multiAnswer && item.multiAnswer.length > 0)
                  ) {
                    flag = flag + 1;
                  }
                } else {
                  if (!item.answer) {
                    flag = flag + 1;
                  }
                }
              }
            }
          }

          if (!flag) {
            try {
              let cryptedText = CryptoJS.AES.encrypt(
                JSON.stringify(AnswerListFinal),
                "secretkey123"
              ).toString();
              localStorage.setItem("myAnswers", JSON.stringify(cryptedText));
            } catch (error) {
              //console.log("not saved!");
            }

            ////console.log("isFeedback----------->", isFeedback);

            if (isFeedback && type2 !== 2) {
              this.setState({ showFeedbackModal: true });
            } else {
              CurrQuesIndex = CurrQuesIndex + 1;

              this.setState({ CurrQuesIndex }, () => {
                this.setState({
                  ShowNotAttempted: false,
                  showFeedbackModal: false,
                });

                this.handleSubmitAppear();
              });
            }
          } else {
            this.setState({ ShowNotAttempted: true });
          }

          // //console.log("CurrQuesIndex------>", CurrQuesIndex);
          // //console.log("questionsList.length------>", questionsList.length);
          // //console.log("itemQ------>", itemQ);

          if (itemQ && itemQ.seconds && !this.state.disableTimer) {
            if (CurrQuesIndex < questionsList.length) {
              let setTimeoutRef = setTimeout(
                () => this.nextQues(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            } else {
              let setTimeoutRef = setTimeout(
                () => this.saveAnswers(),
                itemQ.seconds * 1000
              );
              this.setState(
                {
                  timeCounter: itemQ.seconds,
                  setTimeoutRef: setTimeoutRef,
                  setTimeoutInit: moment().unix(),
                },
                () => {
                  let setIntervalRef = setInterval(
                    () =>
                      this.setState({
                        timeCounter:
                          this.state.timeCounter > 0
                            ? this.state.timeCounter - 1
                            : 0,
                      }),
                    1000
                  );
                  this.setState({ setIntervalRef: setIntervalRef });
                }
              );
            }
          }
        } else if (CurrQuesIndex === questionsList.length) {
          ////console.log("222222222------>", CurrQuesIndex);

          let questionId =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1].id
              : "";
          let questionData =
            questionsList &&
              questionsList[CurrQuesIndex - 1] &&
              questionsList[CurrQuesIndex - 1].id
              ? questionsList[CurrQuesIndex - 1]
              : {};

          if (answersList && answersList.length > 0) {
            let getIndex2 = answersList.findIndex(
              (prev) => prev.questionId === questionId
            );
            if (getIndex2 !== -1) {
              let item = answersList[getIndex2];

              //New added feedback
              if (
                item.answer &&
                questionData &&
                questionData.optionsList &&
                questionData.optionsList.length > 0
              ) {
                let optionList = questionData.optionsList;

                let getIndex5 = optionList.findIndex(
                  (prev) => prev.name === item.answer
                );
                if (getIndex5 !== -1) {
                  isFeedback = optionList[getIndex5]["isFeedback"]
                    ? true
                    : false;
                }
              }
            }
          }

          if (isFeedback && type2 !== 2) {
            this.setState({ showFeedbackModal: true });
          }
        }
      }
    });
  };

  submitFeedback = () => {
    let { CurrQuesIndex } = this.state;

    let { questions } = this.props;
    let { questionsList } = questions;

    if (questionsList && questionsList.length > 0) {
      if (CurrQuesIndex === questionsList.length) {
        this.setState({ showFeedbackModal: false }, () => {
          this.handleSubmitAppear();
        });
      } else {
        CurrQuesIndex = CurrQuesIndex + 1;
        this.setState({ CurrQuesIndex }, () => {
          this.setState({ ShowNotAttempted: false, showFeedbackModal: false });
          this.handleSubmitAppear();
        });
      }
    }
  };

  closeFeedbackModal = () => {
    this.setState({ showFeedbackModal: false });
  };

  handleSubmitAppear = () => {
    let { CurrQuesIndex } = this.state;
    let { questions } = this.props;
    let { questionsList } = questions;

    setTimeout(() => {
      if (
        questionsList &&
        questionsList.length > 0 &&
        questionsList.length === CurrQuesIndex
      ) {
        this.setState({ ShowSubmitButton: true });
      } else {
        this.setState({ ShowSubmitButton: false });
      }
    }, 300);
  };

  handleRadio = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    let { CurrQuesIndex } = this.state;

    if (this.state.radioButton === currentOption.id) {
      this.setState({ radioButton: null });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          "",
          0,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    } else {
      // //console.log("currentOption----------------------IIIIIIIIIIIIIIIIIIIIIIIII--------------------->",currentOption)
      this.setState({ radioButton: currentOption.id });
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          Index,
          GroupQuestionOnlyList
        )
      );
    }

    this.setState({ radioButton: null });

    // if(!ques.parentId){
    //   setTimeout(()=>this.nextQues(), 300);
    // }
    // setTimeout(()=>this.checkFeedback(), 300);

    let resTime = 0;
    if (this.state.setTimeoutInit) {
      const then = moment.unix(this.state.setTimeoutInit);
      resTime = moment().diff(then, "milliseconds");
    } else {
      resTime = 0;
    }

    this.props.dispatch(
      questionsActions.handleRecordResTime(
        resTime,
        ques,
        answersList,
        questionsList,
        surveyScreenData,
        GroupQuestionOnlyList
      )
    );

    // //console.log("-----questionsListlength---->", questionsList.length);
    // //console.log("-----CurrQuesIndex---->", CurrQuesIndex);

    if (questionsList && questionsList.length > 0 && !this.state.disableTimer) {
      if (questionsList.length - 1 >= CurrQuesIndex) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }

      if (CurrQuesIndex === questionsList.length) {
        this.saveAnswers();
      } else if (CurrQuesIndex <= questionsList.length - 1) {
        clearTimeout(this.state.setTimeoutRef);
        clearInterval(this.state.setIntervalRef);
      }
    }

    setTimeout(() => this.nextQues(), 300);
  };

  handleCheckInput = (Index, ques, currentOption) => {
    this.setState({ clicked: currentOption.id });

    let { questions } = this.props;
    let {
      questionsList,
      answersList,
      surveyScreenData,
      GroupQuestionOnlyList,
    } = questions;

    if (true) {
      this.setState({ radioButton: currentOption.id });
      // //console.log("currentOption::", currentOption)
      this.props.dispatch(
        questionsActions.handleSubmitPreChange(
          ques,
          answersList,
          questionsList,
          currentOption,
          currentOption.weightage,
          surveyScreenData,
          "",
          GroupQuestionOnlyList
        )
      );
    }

    // setTimeout(()=>this.nextQues(), 300);
  };

  goToInstructionPage = () => {
    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData.isInstruction) {
      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: false,
        showThankyouScreen: false,
        instructionPage: true,
      });
    } else {
      let { questionsList } = questions;
      let itemQ =
        questionsList && questionsList.length > 0 ? questionsList[0] : {};
      ////console.log("itemQ--01-->", itemQ);

      if (itemQ && itemQ.seconds && !this.state.disableTimer) {
        ////console.log("Seconds--->", itemQ.seconds * 1000);
        let setTimeoutRef = setTimeout(
          () => this.nextQues(),
          itemQ.seconds * 1000
        );
        this.setState(
          {
            timeCounter: itemQ.seconds,
            setTimeoutRef: setTimeoutRef,
            setTimeoutInit: moment().unix(),
          },
          () => {
            let setIntervalRef = setInterval(
              () =>
                this.setState({
                  timeCounter:
                    this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
                }),
              1000
            );
            this.setState({ setIntervalRef: setIntervalRef });
          }
        );
      }

      this.setState({
        showWelcomeScreen: false,
        showQuestionScreen: true,
        showThankyouScreen: false,
        instructionPage: false,
      });
    }
    window.scrollTo(0, 0);
  };

  goToQuestionPage = () => {
    let { questions } = this.props;
    let { questionsList } = questions;
    let itemQ =
      questionsList && questionsList.length > 0 ? questionsList[0] : {};
    ////console.log("itemQ--02-->", itemQ);

    if (itemQ && itemQ.seconds && !this.state.disableTimer) {
      ////console.log("Seconds--->", itemQ.seconds * 1000);
      let setTimeoutRef = setTimeout(
        () => this.nextQues(),
        itemQ.seconds * 1000
      );
      this.setState(
        {
          timeCounter: itemQ.seconds,
          setTimeoutRef: setTimeoutRef,
          setTimeoutInit: moment().unix(),
        },
        () => {
          let setIntervalRef = setInterval(
            () =>
              this.setState({
                timeCounter:
                  this.state.timeCounter > 0 ? this.state.timeCounter - 1 : 0,
              }),
            1000
          );
          this.setState({ setIntervalRef: setIntervalRef });
        }
      );
    }

    this.setState({
      showWelcomeScreen: false,
      showQuestionScreen: true,
      showThankyouScreen: false,
      instructionPage: false,
    });
    window.scrollTo(0, 0);
  };

  saveAnswers() {

    this.setState({ submitBlock: true });

    let { questions } = this.props;
    let { surveyScreenData } = questions;

    if (surveyScreenData) {
      this.setState({
        afterSubmitData: surveyScreenData,
      });
    }

    let survey = {
      code: this.state.SurveyCode,
    };

    //---------------------- new code ------------------------------------------

    let { questionsList } = questions;

    //---------------------------- basic ---------------------------------------
    let answersList = [];
    let AnswerListFinal =
      answersList && questions.answersList && questions.answersList.length > 0
        ? questions.answersList
        : [];

    if (questionsList && questionsList.length > 0) {
      questionsList.forEach((ques) => {
        if (ques.templateId === 13) {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push({
              ...AnswerListFinal[getIndex],
              SubQuestionList: ques.SubQuestionList,
            });
          }
        } else {
          let getIndex = AnswerListFinal.findIndex(
            (prev) => prev.questionId === ques.id
          );
          if (getIndex !== -1) {
            answersList.push(AnswerListFinal[getIndex]);
          }
        }
      });
    }
    //-------------------------------------------------------------------

    let { CurrQuesIndex } = this.state;
    if (questionsList && questionsList.length > 0) {
      let flag = 0;
      // //console.log(" CurrQuesIndex=====>: ",CurrQuesIndex," questionsList.length=====>: ", questionsList.length)

      if (CurrQuesIndex > 0 && CurrQuesIndex <= questionsList.length) {
        //----------------latestcode ---------------------------

        let questionId =
          questionsList &&
            questionsList[CurrQuesIndex - 1] &&
            questionsList[CurrQuesIndex - 1].id
            ? questionsList[CurrQuesIndex - 1].id
            : "";

        if (answersList && answersList.length > 0) {
          let getIndex2 = answersList.findIndex(
            (prev) => prev.questionId === questionId
          );
          if (getIndex2 !== -1) {
            let item = answersList[getIndex2];

            if (item.isMandatory) {
              let template = item.template;

              if (
                template === 1 ||
                template === 3 ||
                template === 4 ||
                template === 5 ||
                template === 6 ||
                template === 16 ||
                template === 11
              ) {
                if (!item.answer) {
                  flag = flag + 1;
                }
                // //console.log(" template: ",template," answer: ",item.answer," flag: ",flag)
              } else if (template === 13) {
                let isAllAnswered = 0;
                if (
                  item &&
                  item.SubQuestionList &&
                  item.SubQuestionList.length > 0
                ) {
                  item.SubQuestionList.forEach((subQues) => {
                    let getIndex2 = AnswerListFinal.findIndex(
                      (prev) => prev.questionId === subQues.id
                    );

                    if (getIndex2 !== -1) {
                      if (
                        AnswerListFinal &&
                        AnswerListFinal[getIndex2] &&
                        AnswerListFinal[getIndex2].multiAnswer &&
                        AnswerListFinal[getIndex2].multiAnswer.length > 1
                      ) {
                        isAllAnswered++;
                      }
                    }
                  });
                }

                if (item.SubQuestionList.length !== isAllAnswered) {
                  flag = flag + 1;
                }
              } else if (template === 2) {
                if (
                  !(item && item.multiAnswer && item.multiAnswer.length > 0)
                ) {
                  flag = flag + 1;
                }
              } else {
                if (!item.answer) {
                  flag = flag + 1;
                }
              }
            }
          }
        }

        // //console.log("% ===============> flag1 ==================>",flag)
      }

      if (!flag) {
        if (!this.state.isDisableSubmit) {
          clearTimeout(this.state.setTimeoutRef);
          clearInterval(this.state.setIntervalRef);

          //console.log("Answer Submitted!");

          setTimeout(() => {
            this.setState({ showViewReportThankYouButton: true });
          }, 3000)

          this.props.dispatch(
            questionsActions.saveAssessmentAnswers(
              AnswerListFinal,
              survey,
              this.props,
              this.state.IpObj,
              true
            )
          );
        }
        this.setState({ submitMandatory: "" });
      } else {
        this.setState({
          submitMandatory: "Please attempt mandatory question!",
        });
      }
    }

  }


  openDropdownQuestion = (check) => {
    this.setState({ showDropdownQues: check });
  };

  handleDropdownSelect = (value) => {
    this.setState({ dropdownInput: value, showDropdownQues: false });
  };


  handleReport = (type) => {
    if (type === 2) {
      this.props.dispatch(questionsActions.getAssessmentReport({}));
      this.setState({ showReportModal: true });
    } else {
      window.location.reload();
    }
  };

  handleSummaryReport = () => {
    this.props.dispatch(questionsActions.getAssessmentReport({}));
    this.setState({ showSummaryReport: true });
  }

  closeReportModal = () => {
    this.setState({ showReportModal: false });
  };

  closeSummaryReportModal = () => {
    this.setState({ showSummaryReport: false });
  };


  handleLanguage = (item, langList) => {
    //console.log("item------------------->", item)
    if (item.shortName === 'en') {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: 'English', surveyLanguageRTL: false });
    }
    else {
      this.setState({ surveyLanguageCode: item.shortName, surveyLanguageName: item.name, surveyLanguageRTL: item.isRTL });
    }
  }


  handleDownloadStatus = (reportType) => {
    let data = {
      moduleType: "ASSESSMENT"
    }
    this.props.dispatch(assessmentActions.assessmentDownloadStatus(data));
  }






  loadExpertData = () => {
    let { questions } = this.props;
    let { getAssessmenrEmployeeDetailsData } = questions;
    if (getAssessmenrEmployeeDetailsData && getAssessmenrEmployeeDetailsData.name && getAssessmenrEmployeeDetailsData.email) {
      let eleUser = getAssessmenrEmployeeDetailsData;
      let temp2 = {
        employeeId: eleUser.employeeId,
        name: eleUser.name,
        email: eleUser.email,
        mobile: eleUser.mobile,
      };
      this.setState({ crrCodeUserDetails: temp2 });
    }

  }



  handleShowMainSummaryModalBack() {

    this.setState({ showMainSummaryModal: true, showMyExpertList: false, backSummary: false });
  }

  handleShowMainSummaryModal(ele) {

    this.loadExpertData()
    this.setState({ showMainSummaryModal: false, backSummary: true, showMyExpertList: false, crrDetail: ele });
  }

  handleExpertContactModal(ele) {
    this.setState({
      contactExpertSection: ele, topFiveTalent: false
    });
  }

  handleExpertContactModalBack() {
    this.setState({
      contactExpertSection: false, topFiveTalent: true
    });
  }
  handleInputExpertForm(value, name) {
    let { crrCodeUserDetails } = this.state;
    crrCodeUserDetails[name] = value;
    this.setState({ crrCodeUserDetails });
  }

  bookExpert(userDetails, expertDetails) {
    let data = {
      "name": userDetails.name,
      "email": userDetails.email,
      "mobile": userDetails.mobile,
      "message": userDetails.message,
      "expertId": expertDetails.id,
    }

  }

  handleExpertClick() {
    const { history } = this.props;
    history.push('/assessment/expert');
  }

  viewMyExpert = () => {

    this.loadExpertData()
    this.setState({ backSummary: true, showMyExpertList: true })

  }

  onDownloadAssessmentType2ByEmpID = (emp_id, shortName) => {
    console.log("shortName---->", shortName)
    this.props.dispatch(assessmentActions.getUserAssessmentLangReport({
      "shortName": shortName ? shortName : "en"
    }));
  }

  sendPDFMail = (value) => {
    this.props.dispatch(assessmentActions.getAssessmentReportMail({ shortName: value, isTest: true }));
  }

  onLogout = () => {
    questionsActions.assessmentSurveyLogout(this.props);
    this.props.history.push(`/assessment/surveylogin`);
  }
  switchToAdmin = () => {
    this.props.history.push(`/assessment/overview`);
  };
  render() {
    let { questions, panel, assessment, onLogout } = this.props;
    let { getTalentResourcesData } = assessment;

    let {
      getAssessmentStatusData,
      getAssessmenrEmployeeDetailsData,
      getTranslateElementAllData

    } = questions;
    let { getAssessmentReportByEmpIDData } = questions;

    let { surveyLanguageRTL, showPageType } = this.state;


    let createdAt = "";
    if (getAssessmentStatusData && getAssessmentStatusData.createdAt) {
      const timestamp = parseInt(getAssessmentStatusData.createdAt, 10);
      createdAt = moment(timestamp)
        .utcOffset("+05:30")
        .format("DD MMMM, YYYY");
    }



    let {
      showSummaryReport,
      themeType,

    } = this.state;


    let { showReportModal, surveyLanguageCode, surveyLanguageName } = this.state;

    const isMobile = window.innerWidth <= 700;

    let surveyScreenData = {};
    if (questions.surveyScreenData) {
      surveyScreenData = { ...questions.surveyScreenData };
    }

    let bgImage = "";
    let bgColor = "";
    if (surveyScreenData && surveyScreenData.bgImage) {
      bgImage = "url(" + surveyScreenData.bgImage + ")";
    }

    if (surveyScreenData && surveyScreenData.bgColor) {
      bgColor = surveyScreenData.bgColor;
    }


    let welcomeTextDislay = [];
    let instructionTextDislay = [];

    if (surveyScreenData && surveyScreenData.welcomeText) {
      welcomeTextDislay = surveyScreenData.welcomeText;
      instructionTextDislay = surveyScreenData.instructionText;
    }

    let surveytitle = "";
    let bgType = "";

    if (surveyScreenData && surveyScreenData.name) {
      surveytitle = surveyScreenData.name;
      bgType = surveyScreenData.bgType;
    }


    let LanguageList = questions.langList;
    let { getSurveyTemplateByCodeData } = this.props;


    const GetTextByLanguage = (name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = "";
        if (getTranslateElementAllData && getTranslateElementAllData.length > 0) {
          let getIndex = getTranslateElementAllData.findIndex(prev => prev.name === name);
          if (getIndex !== -1) {
            sentence = getTranslateElementAllData && getTranslateElementAllData[getIndex] && getTranslateElementAllData[getIndex]["transl"] && getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] ? getTranslateElementAllData[getIndex]["transl"][surveyLanguageCode] : ""
          }
        }
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    const GetDetailsByLanguage = (element, name, text) => {
      if (surveyLanguageCode && surveyLanguageCode !== "en") {
        let sentence = element && element["details"] && element["details"]["transl"] && element["details"]["transl"][surveyLanguageCode] && element["details"]["transl"][surveyLanguageCode][name] ?
          element["details"]["transl"][surveyLanguageCode][name] : ""
        return sentence ? sentence : text
      } else {
        return text
      }
    }

    function EditButtonFn(name, text) {
      return (
        <>
          {GetTextByLanguage(name, text)}
        </>
      )
    }

    function EditDetailsFn(element, name, text) {
      return (
        <>
          {GetDetailsByLanguage(element, name, text)}
        </>
      )
    }

    function hexToRgbA(hex, opacity) {
      var c;
      if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split("");
        if (c.length == 3) {
          c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = "0x" + c.join("");
        return (
          "rgba(" +
          [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") +
          "," +
          opacity +
          ")"
        );
      }
      throw hex;
    }

    function getTheme(field, init) {
      if (themeType === 2) {

        if (field === "backgroundImage") {
          return 'url("/img/survey-light-bg.webp")'
        }
        else if (field === "welcomeImage") {
          return "url('/img/assessment-welcome-large.webp')"
        }
        else if (field === "text") {
          return '#3D405B'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "textblue") {
          return '#2196F3'
        }
        else if (field === "lightblue") {
          return hexToRgbA('#2196F3', '0.12')
        }
        else if (field === "hoverActive") {
          return 'hover:bg-[' + hexToRgbA('#2196F3', '0.12') + '] hover:border-[#2196F3] hover:text-[#2196F3] '
        }
        else if (field === "grayheader") {
          return ' bg-[' + hexToRgbA('#3D405B', '0.05') + '] '
        }
        else if (field === "textOption") {
          return 'border-[#3D405B] text-[#3D405B] '
        }
        else {
          return init
        }

      } else {
        return init
      }
    }




    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: getAssessmenrEmployeeDetailsData?.name ?? "",
      email: getAssessmenrEmployeeDetailsData?.email ?? "",
      period: getPeriod()
    };


    return (

      <DashboardUser userDetails={userDetails} onLogout={this.onLogout}
        switchToAdmin={this.switchToAdmin}>

        {(showPageType === '1') &&
          <div className="">

            {surveyLanguageRTL ?
              <SummaryRTL
                handleReport={this.handleReport}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleSummaryReport={this.handleSummaryReport}
                getTheme={getTheme}
                backSummary={this.state.backSummary}
                showMyExpertList={this.state.showMyExpertList}
                showMainSummaryModal={this.state.showMainSummaryModal}
                contactExpertSection={this.state.contactExpertSection}
                topFiveTalent={this.state.topFiveTalent}
                handleViewReport={this.handleViewReport}
                closeReportummaryModal={this.closeReportummaryModal}
                handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                handleExpertContactModalBack={this.handleExpertContactModalBack}
                handleExpertContactModal={this.handleExpertContactModal}
                crrDetail={this.state.crrDetail}
                crrCodeUserDetails={this.state.crrCodeUserDetails}
                handleInputExpertForm={this.handleInputExpertForm}
                bookExpert={this.bookExpert}
                viewMyExpert={this.viewMyExpert}
              />
              :
              <Summary
                handleReport={this.handleReport}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                crrSelectedEmp={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleSummaryReport={this.handleSummaryReport}
                getTheme={getTheme}
                backSummary={this.state.backSummary}
                showMyExpertList={this.state.showMyExpertList}
                showMainSummaryModal={this.state.showMainSummaryModal}
                contactExpertSection={this.state.contactExpertSection}
                topFiveTalent={this.state.topFiveTalent}
                handleViewReport={this.handleViewReport}
                closeReportummaryModal={this.closeReportummaryModal}
                handleShowMainSummaryModal={this.handleShowMainSummaryModal}
                handleShowMainSummaryModalBack={this.handleShowMainSummaryModalBack}
                handleExpertContactModalBack={this.handleExpertContactModalBack}
                handleExpertContactModal={this.handleExpertContactModal}
                crrDetail={this.state.crrDetail}
                crrCodeUserDetails={this.state.crrCodeUserDetails}
                handleInputExpertForm={this.handleInputExpertForm}
                bookExpert={this.bookExpert}
                viewMyExpert={this.viewMyExpert}
              />
            }

          </div>
        }

        {showReportModal ? (
          <>
            {surveyLanguageRTL ?
              <AssessmentReportRTL
                surveyLanguageCode={surveyLanguageCode}
                closeReportModal={this.closeReportModal}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                onAssessmentByEmpID={this.onAssessmentByEmpID}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleDownloadStatus={this.handleDownloadStatus}
                getSurveyTemplateByCodeData={getSurveyTemplateByCodeData}

                getTranslateElementAllData={getTranslateElementAllData}
                onDownloadAssessmentType2ByEmpID={this.onDownloadAssessmentType2ByEmpID}
                showPageType={showPageType}

              />
              :
              <AssessmentReport
                surveyLanguageCode={surveyLanguageCode}
                closeReportModal={this.closeReportModal}
                getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
                onAssessmentByEmpID={this.onAssessmentByEmpID}
                getAssessmenrEmployeeDetailsData={getAssessmenrEmployeeDetailsData}
                createdAt={createdAt}
                EditButtonFn={EditButtonFn}
                EditDetailsFn={EditDetailsFn}
                handleDownloadStatus={this.handleDownloadStatus}
                getSurveyTemplateByCodeData={getSurveyTemplateByCodeData}
                sendPDFMail={this.sendPDFMail}
                getTranslateElementAllData={getTranslateElementAllData}
                onDownloadAssessmentType2ByEmpID={this.onDownloadAssessmentType2ByEmpID}
                showPageType={showPageType}
              />
            }
          </>
        ) : null}

        {(showPageType === '3') &&
          <VideoCourse
            getTalentResourcesData={getTalentResourcesData}
            getAssessmentReportByEmpIDData={getAssessmentReportByEmpIDData}
            crrSelectedEmp={getAssessmenrEmployeeDetailsData}
            EditButtonFn={EditButtonFn}
            EditDetailsFn={EditDetailsFn}
            getTheme={getTheme}
            closeVideoCourse={this.closeVideoCourse}
            showReportModal={showReportModal}
            showSummaryReport={showSummaryReport}
            surveyLanguageRTL={surveyLanguageRTL}
          />
        }

      </DashboardUser>
    );
  }
}
function mapStateToProps(state) {
  ////console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, users, panel, assessment } = state;
  return {
    loggingIn,
    questions,
    users,
    panel,
    assessment
  };
}

export default connect(mapStateToProps)(AssessmentOverview);
